import { buildMap } from '@/views/map';
import TinyUri from 'tiny-uri';

let map = null;
let marks = null;
let currentStorageId = null;

pageUnload('pages_delivery', () => {
  if (map) {
    map.destroy();
    map = null;
  }
});

pageLoad('pages_delivery', async () => {
  $('#storage_id').on('change', ({ currentTarget }) => {
    const storageId = parseInt(currentTarget.value);
    const mark = marks.find(mark => mark.storageId === storageId);
    mark.showBalloon();
  });

  const $map = $('#map');
  const mapData = (await buildMap({
    node: $map[0],
    isAutoCenter: false,
    mapType: 'ymap',
    leadProps: $map.data('lead-props'),
    callbacks: {
      showBalloon(mark) {
        selectPlacemark(mark);
      },
      hideBalloon(mark) {
        selectPlacemark(null);
      }
    }
  }));
  map = mapData.map;
  marks = mapData.marks;
});

function selectPlacemark(mark) {
  const $storage = $('#storage_id');
  const storageId = mark?.storageId;

  $storage.val(storageId == null ? 'null' : storageId);
  currentStorageId = storageId;

  updateWidget(mark);
}

function updateWidget(mark) {
  const $widget = $('.ya-taxi-widget');
  $widget.toggle(!!mark);

  if (!mark) { return; }

  const $link = $widget.find('a');
  const $description = $widget.find('.ya-taxi-widget__description');

  const url = $link.prop('href');

  $description.html(mark.markData.name);
  $link.prop(
    'href',
    new TinyUri(url)
      .query.set({
        'end-lat': mark.markData.latitude,
        'end-lon': mark.markData.longitude
      })
      .toString()
  );
}
